export * as RentalInquiryEvents from './events-definition'
